import { checkEnabledFinalReviewerNomenclature } from './featureFlags';

/**
 * Case options for nomenclature terms
 */
export const NomenclatureCase = {
  TITLE_CASE: 'TITLE_CASE', // "Final Reviewer"
  LOWER_CASE: 'LOWER_CASE', // "final reviewer"
  UPPER_CASE: 'UPPER_CASE', // "FINAL REVIEWER"
  PROPER_CASE: 'PROPER_CASE', // "Final reviewer"
} as const;

type NomenclatureCaseType = (typeof NomenclatureCase)[keyof typeof NomenclatureCase];

/**
 * Transforms a string to the specified case
 */
const applyCase = (term: string, caseType: NomenclatureCaseType): string => {
  switch (caseType) {
    case NomenclatureCase.LOWER_CASE:
      return term.toLowerCase();
    case NomenclatureCase.UPPER_CASE:
      return term.toUpperCase();
    case NomenclatureCase.PROPER_CASE:
      return term.charAt(0).toUpperCase() + term.slice(1).toLowerCase();
    default:
      // TITLE_CASE is the default
      return term
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
  }
};

/**
 * Pre-defined getters for common reviewer terminology
 * Use these for consistency across the application
 */

// "Final Reviewer" or "Manager" (configurable case)
export const getReviewerTerm = (caseType: NomenclatureCaseType = NomenclatureCase.TITLE_CASE): string => {
  const baseTerm = checkEnabledFinalReviewerNomenclature() ? 'Final Reviewer' : 'Manager';
  return applyCase(baseTerm, caseType);
};

// "Additional Reviewer" or "Dotted Line Manager" (configurable case)
export const getAdditionalReviewerTerm = (caseType: NomenclatureCaseType = NomenclatureCase.TITLE_CASE): string => {
  const baseTerm = checkEnabledFinalReviewerNomenclature() ? 'Additional Reviewer' : 'Dotted Line Manager';
  return applyCase(baseTerm, caseType);
};
